<template>
  <div class="home general">
    <h1 class="section-title">
      Conexión {{ connection.connectionCode || '' }}
    </h1>

    <va-data-table
      class="ekitable"
      :items="summary"
      :columns="summaryColumns"
      no-data-html="<div class='no-data'>Cargando...</div>"
      :sticky-header="true"
      :loading="false"
      loading-text=""
    />

    <h2 class="section-title">Estado de la conexión</h2>
    <va-data-table
      class="ekitable"
      :items="events"
      :columns="eventColumns"
      no-data-html="<div class='no-data'>Sin eventos</div>"
      :sticky-header="true"
      :loading="false"
      loading-text=""
    >
      <template #cell(createdAt)="{ rowData }">
        {{ formatWhen(rowData.createdAt) }}
      </template>
      <template #cell(event)="{ rowData }">
        {{ eventLabel(rowData.event) }}
      </template>
    </va-data-table>

    <h2 class="section-title">Canciones reproducidas</h2>
    <va-data-table
      class="ekitable"
      :items="songs"
      :columns="songColumns"
      no-data-html="<div class='no-data'>Sin canciones</div>"
      :sticky-header="true"
      :loading="false"
      loading-text=""
    >
      <template #cell(createdAt)="{ rowData }">
        {{ formatWhen(rowData.createdAt) }}
      </template>
    </va-data-table>
  </div>
</template>
<script>
import requester from "@/services/requester";

export default {
  data() {
    return {
      connection: {},
      summary: [],
      events: [],
      songs: [],
      summaryColumns: [
        { key: 'label', sortable: false, label: 'Dato' },
        { key: 'value', sortable: false, label: 'Valor' }
      ],
      eventColumns: [
        { key: 'createdAt', sortable: false, label: 'Hora' },
        { key: 'event', sortable: false, label: 'Estado' },
        { key: 'reason', sortable: false, label: 'Detalle' }
      ],
      songColumns: [
        { key: 'songHistoryId', sortable: false, label: 'Id de historial' },
        { key: 'num', sortable: false, label: 'Número' },
        { key: 'title', sortable: false, label: 'Canción' },
        { key: 'createdAt', sortable: false, label: 'Hora' }
      ]
    }
  },
  methods: {
    formatWhen(value) {
      if (!value) {
        return '';
      }
      return new Date(value).toLocaleString('es-EC', { timeZone: 'America/Guayaquil' });
    },
    ownerLabel(owner) {
      if (owner.fullname && owner.email) {
        return owner.fullname + ' — ' + owner.email;
      }
      return owner.fullname || owner.email || '';
    },
    statusLabel(status) {
      if (status === 'connected') {
        return 'Conectado';
      }
      if (status === 'disconnected') {
        return 'Desconectado';
      }
      return status || '';
    },
    eventLabel(event) {
      if (event === 'connected') {
        return 'Conectado';
      }
      if (event === 'disconnected') {
        return 'Desconectado';
      }
      if (event === 'intentional_disconnect') {
        return 'Desconexión intencional';
      }
      return event || '';
    },
    async getDetail() {
      const data = await requester.Get('/control-connection/' + this.$route.params.id, true);
      if (data.status !== 200) {
        return;
      }
      const connection = data.data.connection;
      this.connection = connection;
      this.events = connection.events || [];
      this.songs = (connection.playedSongs || []).map((played) => ({
        songHistoryId: played.songHistoryId,
        num: played.history && played.history.songHis ? played.history.songHis.num : '',
        title: played.history && played.history.songHis ? played.history.songHis.title : '',
        createdAt: played.createdAt
      }));
      this.summary = [
        { label: 'Hora de conexión', value: this.formatWhen(connection.connectedAt) },
        { label: 'Hora de desconexión', value: this.formatWhen(connection.disconnectedAt) },
        { label: 'Dueño de la licencia', value: connection.licenseOwner ? this.ownerLabel(connection.licenseOwner) : '' },
        { label: 'Código de acceso', value: connection.connectionCode },
        { label: 'Sala', value: connection.room },
        { label: 'IP', value: connection.ip || '' },
        { label: 'Estado', value: this.statusLabel(connection.status) },
        { label: 'Motivo', value: connection.disconnectReason || '' },
        { label: 'Navegador', value: connection.userAgent || '' }
      ];
      this.$store.dispatch('utils/setUpCrumbDetail', { crumbLabel: connection.connectionCode });
    }
  },
  created() {
    this.getDetail();
  }
}
</script>
